export const REFRESH_TOKEN = "REFRESH_TOKEN";

export const FETCH_ME = 'FETCH_ME';
export const FETCH_ME_SUCCESS = 'FETCH_ME_SUCCESS';
export const FETCH_SECURITY_FAIL = 'FETCH_SECURITY_FAIL';
export const FETCH_SECURITY_SUCCESS = 'FETCH_SECURITY_SUCCESS';
export const FETCH_SIWE_NONCE_FAIL = 'FETCH_SIWE_NONCE_FAIL';
export const FETCH_SIWE_NONCE_SUCCESS = 'FETCH_SIWE_NONCE_SUCCESS';
export const FETCH_USER_FAIL = 'FETCH_USER_FAIL';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_ME_FAIL = 'FETCH_ME_FAIL';
export const NOT_LOGGED_IN = 'NOT_LOGGED_IN';
export const GENERIC_ERROR = 'GENERIC_ERROR';

export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const SIGN_OUT_BEGIN = 'SIGN_OUT_BEGIN';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILURE = 'SIGN_OUT_FAILURE';

export const DISABLE_OTP_SUCCESS = 'DISABLE_OTP_SUCCESS';
export const DISABLE_OTP_FAIL = 'DISABLE_OTP_FAIL';
export const ENABLE_OTP_SUCCESS = 'ENABLE_OTP_SUCCESS';
export const ENABLE_OTP_FAIL = 'ENABLE_OTP_FAIL';
export const ACTIVATE_OTP_SUCCESS = 'ACTIVATE_OTP_SUCCESS';
export const ACTIVATE_OTP_FAIL = 'ACTIVATE_OTP_FAIL';
export const TOGGLE_SIWE_SUCCESS = 'TOGGLE_SIWE_SUCCESS';
export const TOGGLE_SIWE_FAIL = 'TOGGLE_SIWE_FAIL';

export const VALIDATE_PASSWORD_SUCCESS = 'VALIDATE_PASSWORD_SUCCESS';
export const VALIDATE_PASSWORD_FAIL = 'VALIDATE_PASSWORD_FAIL';

export const UPDATE_PWD_SUCCESS = 'UPDATE_PWD_SUCCESS';
export const UPDATE_PWD_FAIL = 'UPDATE_PWD_FAIL';

export const FETCH_IDENTITY_SUCCESS = 'FETCH_IDENTITY_SUCCESS';
export const FETCH_IDENTITY_FAIL = 'FETCH_IDENTITY_FAIL';
export const CREATE_IDENTITY_SUCCESS = 'CREATE_IDENTITY_SUCCESS';
export const CREATE_IDENTITY_FAIL = 'CREATE_IDENTITY_FAIL';
export const CREATE_DOCS_SUCCESS = 'CREATE_DOCS_SUCCESS';
export const CREATE_DOCS_FAIL = 'CREATE_DOCS_FAIL';

export const CREATE_TOKEN_SUCCESS = 'CREATE_TOKEN_SUCCESS';
export const CREATE_TOKEN_FAIL = 'CREATE_TOKEN_FAIL';
export const DELETE_TOKEN_SUCCESS = 'DELETE_TOKEN_SUCCESS';
export const DELETE_TOKEN_FAIL = 'DELETE_TOKEN_FAIL';
export const FETCH_TOKENS_SUCCESS = 'FETCH_TOKENS_SUCCESS';
export const FETCH_TOKENS_FAIL = 'FETCH_TOKENS_FAIL';

export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL = 'FETCH_ORDERS_FAIL';
export const FETCH_LATEST_ORDERS_SUCCESS = 'FETCH_LATEST_ORDERS_SUCCESS';
export const FETCH_LATEST_ORDERS_FAIL = 'FETCH_LATEST_ORDERS_FAIL';
export const FETCH_OPEN_ORDERS_SUCCESS = 'FETCH_OPEN_ORDERS_SUCCESS';
export const FETCH_OPEN_ORDERS_FAIL = 'FETCH_OPEN_ORDERS_FAIL';
export const CREATE_ORDERS_SUCCESS = 'CREATE_ORDERS_SUCCESS';
export const CREATE_ORDERS_FAIL = 'CREATE_ORDERS_FAIL';
export const DELETE_ORDER_SUCCESS = 'DELETE_ORDER_SUCCESS';
export const DELETE_ORDER_FAIL = 'DELETE_ORDER_FAIL';

export const FETCH_BALANCES_SUCCESS = 'FETCH_BALANCES_SUCCESS';
export const FETCH_BALANCES_FAIL = 'FETCH_BALANCES_FAIL';

export const FETCH_OHLC_SUCCESS = 'FETCH_OHLC_SUCCESS';
export const FETCH_OHLC_FAIL = 'FETCH_OHLC_FAIL';

export const FETCH_REFERRALS_SUCCESS = 'FETCH_REFERRALS_SUCCESS';
export const FETCH_REFERRALS_FAIL = 'FETCH_REFERRALS_FAIL';

export const FETCH_TRADE_FEES_SUCCESS = 'FETCH_TRADE_FEES_SUCCESS';
export const FETCH_TRADE_FEES_FAIL = 'FETCH_TRADE_FEES_FAIL';
export const FETCH_WITHDRAWAL_FEES_SUCCESS = 'FETCH_WITHDRAWAL_FEES_SUCCESS';
export const FETCH_WITHDRAWAL_FEES_FAIL = 'FETCH_WITHDRAWAL_FEES_FAIL';

export const FETCH_ORDER_LIQUIDITY_SUCCESS = 'FETCH_ORDER_LIQUIDITY_SUCCESS';

export const FETCH_HISTORY_SUCCESS = 'FETCH_HISTORY_SUCCESS';
export const FETCH_HISTORY_FAIL = 'FETCH_HISTORY_FAIL';
export const FETCH_SUB_HISTORY_SUCCESS = 'FETCH_SUB_HISTORY_SUCCESS';
export const FETCH_SUB_HISTORY_FAIL = 'FETCH_SUB_HISTORY_FAIL';
export const FETCH_ORDER_HISTORY_SUCCESS = 'FETCH_ORDER_HISTORY_SUCCESS';
export const FETCH_ORDER_HISTORY_FAIL = 'FETCH_ORDER_HISTORY_FAIL';
export const EXPORT_HISTORY_SUCCESS = 'EXPORT_HISTORY_SUCCESS';
export const EXPORT_HISTORY_FAIL = 'EXPORT_HISTORY_FAIL';

export const FETCH_ADDRESS_SUCCESS = 'FETCH_ADDRESS_SUCCESS';
export const FETCH_ADDRESS_FAIL = 'FETCH_ADDRESS_FAIL';
export const CREATE_ADDRESS_SUCCESS = 'CREATE_ADDRESS_SUCCESS';
export const CREATE_ADDRESS_FAIL = 'CREATE_ADDRESS_FAIL';
export const WITHDRAW_FUNDS_SUCCESS = 'WITHDRAW_FUNDS_SUCCESS';
export const WITHDRAW_FUNDS_FAIL = 'WITHDRAW_FUNDS_FAIL';

export const FETCH_TRANSACTIONS_SUCCESS = 'FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_FAIL = 'FETCH_TRANSACTIONS_FAIL';

export const FETCH_EXCHANGE_RATE_SUCCESS = 'FETCH_EXCHANGE_RATE_SUCCESS';
export const FETCH_EXCHANGE_RATE_FAIL = 'FETCH_EXCHANGE_RATE_FAIL';

export const FETCH_ASSET_VALUE_SUCCESS = 'FETCH_ASSET_VALUE_SUCCESS';
export const FETCH_ASSET_VALUE_FAIL = 'FETCH_ASSET_VALUE_FAIL';

export const FETCH_QUOTE_SUCCESS = 'FETCH_QUOTE_SUCCESS';
export const FETCH_QUOTE_FAIL = 'FETCH_QUOTE_FAIL';

export const FETCH_GLASSBOOKS_SUCCESS = 'FETCH_GLASSBOOKS_SUCCESS';
export const FETCH_GLASSBOOKS_FAIL = 'FETCH_GLASSBOOKS_FAIL';

export const FETCH_STATUS_SUCCESS = 'FETCH_STATUS_SUCCESS';
export const FETCH_STATUS_FAIL = 'FETCH_STATUS_FAIL';

export const FETCH_MESSAGES_SUCCESS = 'FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_FAIL = 'FETCH_MESSAGES_FAIL';

export const FETCH_LEDGER_SUCCESS = 'FETCH_LEDGER_SUCCESS';
export const FETCH_LEDGER_FAIL = 'FETCH_LEDGER_FAIL';

export const FETCH_DAILY_LEDGER_SUCCESS = 'FETCH_DAILY_LEDGER_SUCCESS';
export const FETCH_DAILY_LEDGER_FAIL = 'FETCH_DAILY_LEDGER_FAIL';

export const FETCH_DAILY_PRICES_SUCCESS = 'FETCH_DAILY_PRICES_SUCCESS';
export const FETCH_DAILY_PRICES_FAIL = 'FETCH_DAILY_PRICES_FAIL';

export const FETCH_LAST_LOGIN_VALUE_SUCCESS = 'FETCH_LAST_LOGIN_VALUE_SUCCESS';
export const FETCH_LAST_LOGIN_VALUE_FAIL = 'FETCH_LAST_LOGIN_VALUE_FAIL';

export const FETCH_FX_SNAPSHOT_DAY_SUCCESS = 'FETCH_FX_SNAPSHOT_DAY_SUCCESS';
export const FETCH_FX_SNAPSHOT_DAY_FAIL = 'FETCH_FX_SNAPSHOT_DAY_FAIL';
export const FETCH_FX_SNAPSHOT_WEEK_SUCCESS = 'FETCH_FX_SNAPSHOT_WEEK_SUCCESS';
export const FETCH_FX_SNAPSHOT_WEEK_FAIL = 'FETCH_FX_SNAPSHOT_WEEK_FAIL';

export const FETCH_ASSETS_SUCCESS = 'FETCH_ASSETS_SUCCESS';
export const FETCH_ASSETS_FAIL = 'FETCH_ASSETS_FAIL';
export const FETCH_PAIRS_SUCCESS = 'FETCH_PAIRS_SUCCESS';
export const FETCH_PAIRS_FAIL = 'FETCH_PAIRS_FAIL';

export const VALIDATE_IP_SUCCESS = 'VALIDATE_IP_SUCCESS';
export const VALIDATE_IP_FAIL = 'VALIDATE_IP_FAIL';

export const REQUEST_SDK_TOKEN_GENERATION_SUCCESS = 'REQUEST_SDK_TOKEN_GENERATION_SUCCESS';
export const REQUEST_SDK_TOKEN_GENERATION_FAILED = 'REQUEST_SDK_TOKEN_GENERATION_FAILED';

export const REQUEST_CREATE_CHECK_SUCCESS = 'REQUEST_CREATE_CHECK_SUCCESS';
export const REQUEST_CREATE_CHECK_FAILED = 'REQUEST_CREATE_CHECK_FAILED';

export const REQUEST_VERIFICATIONS_STATUS_SUCCESS = 'REQUEST_VERIFICATIONS_STATUS_SUCCESS';
export const REQUEST_VERIFICATIONS_STATUS_FAILURE = 'REQUEST_VERIFICATIONS_STATUS_FAILURE';
export const REQUEST_VERIFICATIONS_STATUS_BEGIN = 'REQUEST_VERIFICATIONS_STATUS_BEGIN';

export const TOGGLE_TEMP_ANON_SUCCESS = 'TOGGLE_TEMP_ANON_SUCCESS';
export const TOGGLE_TEMP_ANON_FAIL = 'TOGGLE_TEMP_ANON_FAIL';

export const CREATE_MASTER_PASSWORD_SUCCESS = 'CREATE_MASTER_PASSWORD_SUCCESS';
export const CREATE_MASTER_PASSWORD_FAIL = 'CREATE_MASTER_PASSWORD_FAIL';
export const RESET_MASTER_PASSWORD_SUCCESS = 'RESET_MASTER_PASSWORD_SUCCESS';
export const RESET_MASTER_PASSWORD_FAIL = 'RESET_MASTER_PASSWORD_FAIL';

export const ACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS = 'ACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS';
export const ACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL = 'ACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL';
export const DEACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS = 'DEACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS';
export const DEACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL = 'DEACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL';

export const FETCH_LOGIN_HISTORY_SUCCESS = 'FETCH_LOGIN_HISTORY_SUCCESS';
export const FETCH_LOGIN_HISTORY_FAIL = 'FETCH_LOGIN_HISTORY_FAIL';

export const CREATE_OTC_ORDER_SUCCESS = 'CREATE_OTC_ORDER_SUCCESS';
export const CREATE_OTC_ORDER_FAIL = 'CREATE_OTC_ORDER_FAIL';

export const FETCH_OTC_QUOTE_SUCCESS = 'FETCH_OTC_QUOTE_SUCCESS';
export const FETCH_OTC_QUOTE_FAIL = 'FETCH_OTC_QUOTE_FAIL';

export const FETCH_TST_QUOTE_SUCCESS = 'FETCH_TST_QUOTE_SUCCESS';
export const FETCH_TST_QUOTE_FAIL = 'FETCH_TST_QUOTE_FAIL';

export const CREATE_TST_ORDER_SUCCESS = 'CREATE_TST_ORDER_SUCCESS';
export const CREATE_TST_ORDER_FAIL = 'CREATE_TST_ORDER_FAIL';

export const FETCH_TST_SUPPLY_SUCCESS = 'FETCH_TST_SUPPLY_SUCCESS';
export const FETCH_TST_SUPPLY_FAIL = 'FETCH_TST_SUPPLY_FAIL';

export const APPROVE_WITHDRAWAL_SUCCESS = 'APPROVE_WITHDRAWAL_SUCCESS';
export const APPROVE_WITHDRAWAL_FAIL = 'APPROVE_WITHDRAWAL_FAIL';
export const DENY_WITHDRAWAL_SUCCESS = 'DENY_WITHDRAWAL_SUCCESS';
export const DENY_WITHDRAWAL_FAIL = 'DENY_WITHDRAWAL_FAIL';

export const REQUEST_EMAIL_CHANGE_SUCCESS = 'REQUEST_EMAIL_CHANGE_SUCCESS';
export const REQUEST_EMAIL_CHANGE_FAIL = 'REQUEST_EMAIL_CHANGE_FAIL';

export const FETCH_APPROVALS_SUCCESS = 'FETCH_APPROVALS_SUCCESS';
export const FETCH_APPROVALS_FAIL = 'FETCH_APPROVALS_FAIL';

export const FETCH_TST_ASSET_VALUE_SUCCESS = 'FETCH_TST_ASSET_VALUE_SUCCESS';
export const FETCH_TST_ASSET_VALUE_FAIL = 'FETCH_TST_ASSET_VALUE_FAIL';

export const GENERATE_STATEMENT_SUCCESS = 'GENERATE_STATEMENT_SUCCESS';
export const GENERATE_STATEMENT_FAIL = 'GENERATE_STATEMENT_FAIL';

export const FETCH_ADDRESSBOOK_ADDRESSES_BEGIN = 'FETCH_ADDRESSBOOK_ADDRESSES_BEGIN';
export const FETCH_ADDRESSBOOK_ADDRESSES_SUCCESS = 'FETCH_ADDRESSBOOK_ADDRESSES_SUCCESS';
export const FETCH_ADDRESSBOOK_ADDRESSES_FAIL = 'FETCH_ADDRESSBOOK_ADDRESSES_FAIL';
export const CREATE_ADDRESSBOOK_ADDRESS_SUCCESS = 'CREATE_ADDRESSBOOK_ADDRESS_SUCCESS';
export const CREATE_ADDRESSBOOK_ADDRESS_FAIL = 'CREATE_ADDRESSBOOK_ADDRESS_FAIL';
export const UPDATE_ADDRESSBOOK_ADDRESS_SUCCESS = 'UPDATE_ADDRESSBOOK_ADDRESS_SUCCESS';
export const UPDATE_ADDRESSBOOK_ADDRESS_FAIL = 'UPDATE_ADDRESSBOOK_ADDRESS_FAIL';
export const DELETE_ADDRESSBOOK_ADDRESS_SUCCESS = 'DELETE_ADDRESSBOOK_ADDRESS_SUCCESS';
export const DELETE_ADDRESSBOOK_ADDRESS_FAIL = 'DELETE_ADDRESSBOOK_ADDRESS_FAIL';

export const ENABLE_ADDRESSBOOK_WHITELIST_SUCCESS = 'ENABLE_ADDRESSBOOK_WHITELIST_SUCCESS';
export const ENABLE_ADDRESSBOOK_WHITELIST_FAIL = 'ENABLE_ADDRESSBOOK_WHITELIST_FAIL';
export const DISABLE_ADDRESSBOOK_WHITELIST_SUCCESS = 'DISABLE_ADDRESSBOOK_WHITELIST_SUCCESS';
export const DISABLE_ADDRESSBOOK_WHITELIST_FAIL = 'DISABLE_ADDRESSBOOK_WHITELIST_FAIL';

export const UPDATE_USER_TERMS_VERSION_SUCCESS = 'UPDATE_USER_TERMS_VERSION_SUCCESS';
export const UPDATE_USER_TERMS_VERSION_FAIL = 'UPDATE_USER_TERMS_VERSION_FAIL';

export const FETCH_LOGIN_SESSIONS_SUCCESS = 'FETCH_LOGIN_SESSIONS_SUCCESS';
export const FETCH_LOGIN_SESSIONS_FAIL = 'FETCH_LOGIN_SESSIONS_FAIL';
export const EXPIRE_LOGIN_SESSION_SUCCESS = 'EXPIRE_LOGIN_SESSION_SUCCESS';
export const EXPIRE_LOGIN_SESSION_FAIL = 'EXPIRE_LOGIN_SESSION_FAIL';

export const FETCH_COUNTRIES_BEGIN = 'FETCH_COUNTRIES_BEGIN';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_FAIL = 'FETCH_COUNTRIES_FAIL';

export const GET_AUTOMATION_FLOWS_BEGIN = 'GET_AUTOMATION_FLOWS_BEGIN';
export const GET_AUTOMATION_FLOWS_SUCCESS = 'GET_AUTOMATION_FLOWS_SUCCESS';
export const GET_AUTOMATION_FLOWS_FAIL = 'GET_AUTOMATION_FLOWS_FAIL';

export const CREATE_AUTOMATION_FLOW_BEGIN = 'CREATE_AUTOMATION_FLOW_BEGIN';
export const CREATE_AUTOMATION_FLOW_SUCCESS = 'CREATE_AUTOMATION_FLOW_SUCCESS';
export const CREATE_AUTOMATION_FLOW_FAIL = 'CREATE_AUTOMATION_FLOW_FAIL';

export const UPDATE_AUTOMATION_FLOW_BEGIN = 'UPDATE_AUTOMATION_FLOW_BEGIN';
export const UPDATE_AUTOMATION_FLOW_SUCCESS = 'UPDATE_AUTOMATION_FLOW_SUCCESS';
export const UPDATE_AUTOMATION_FLOW_FAIL = 'UPDATE_AUTOMATION_FLOW_FAIL';

export const DELETE_AUTOMATION_FLOW_BEGIN = 'DELETE_AUTOMATION_FLOW_BEGIN';
export const DELETE_AUTOMATION_FLOW_SUCCESS = 'DELETE_AUTOMATION_FLOW_SUCCESS';
export const DELETE_AUTOMATION_FLOW_FAIL = 'DELETE_AUTOMATION_FLOW_FAIL';

export const GET_AUTOMATION_LOGS_BEGIN = 'GET_AUTOMATION_LOGS_BEGIN';
export const GET_AUTOMATION_LOGS_SUCCESS = 'GET_AUTOMATION_LOGS_SUCCESS';
export const GET_AUTOMATION_LOGS_FAIL = 'GET_AUTOMATION_LOGS_FAIL';

export const GET_PENDING_EUR_TRANSACTIONS_BEGIN = 'GET_PENDING_EUR_TRANSACTIONS_BEGIN';
export const GET_PENDING_EUR_TRANSACTIONS_SUCCESS = 'GET_PENDING_EUR_TRANSACTIONS_SUCCESS';
export const GET_PENDING_EUR_TRANSACTIONS_FAIL = 'GET_PENDING_EUR_TRANSACTIONS_FAIL';

export const CREATE_PENDING_EUR_TRANSACTIONS_BEGIN = 'CREATE_PENDING_EUR_TRANSACTIONS_BEGIN';
export const CREATE_PENDING_EUR_TRANSACTIONS_SUCCESS = 'CREATE_PENDING_EUR_TRANSACTIONS_SUCCESS';
export const CREATE_PENDING_EUR_TRANSACTIONS_FAIL = 'CREATE_PENDING_EUR_TRANSACTIONS_FAIL';

export const DELETE_PENDING_EUR_TRANSACTIONS_BEGIN = 'DELETE_PENDING_EUR_TRANSACTIONS_BEGIN';
export const DELETE_PENDING_EUR_TRANSACTIONS_SUCCESS = 'DELETE_PENDING_EUR_TRANSACTIONS_SUCCESS';
export const DELETE_PENDING_EUR_TRANSACTIONS_FAIL = 'DELETE_PENDING_EUR_TRANSACTIONS_FAIL';

export const GET_MARKET_SUMMARY_BEGIN = 'GET_MARKET_SUMMARY_BEGIN';
export const GET_MARKET_SUMMARY_SUCCESS = 'GET_MARKET_SUMMARY_SUCCESS';
export const GET_MARKET_SUMMARY_FAIL = 'GET_MARKET_SUMMARY_FAIL';

export const GET_MARKET_ASSET_BEGIN = 'GET_MARKET_ASSET_BEGIN';
export const GET_MARKET_ASSET_SUCCESS = 'GET_MARKET_ASSET_SUCCESS';
export const GET_MARKET_ASSET_FAIL = 'GET_MARKET_ASSET_FAIL';

export const SET_SELECTED_MARKET_ASSET = 'SET_SELECTED_MARKET_ASSET';
export const SET_LOCAL_CURRENCY = 'SET_LOCAL_CURRENCY';

export const GET_MARKET_DATA_BEGIN = 'GET_MARKET_DATA_BEGIN';
export const GET_MARKET_DATA_SUCCESS = 'GET_MARKET_DATA_SUCCESS';
export const GET_MARKET_DATA_FAIL = 'GET_MARKET_DATA_FAIL';

export const GET_ALL_MARKET_DATA_BEGIN = 'GET_ALL_MARKET_DATA_BEGIN';
export const GET_ALL_MARKET_DATA_SUCCESS = 'GET_ALL_MARKET_DATA_SUCCESS';
export const GET_ALL_MARKET_DATA_FAIL = 'GET_ALL_MARKET_DATA_FAIL';

export const GET_MARKET_NEWS_BEGIN = 'GET_MARKET_NEWS_BEGIN';
export const GET_MARKET_NEWS_SUCCESS = 'GET_MARKET_NEWS_SUCCESS';
export const GET_MARKET_NEWS_FAIL = 'GET_MARKET_NEWS_FAIL';

export const CREATE_TRUELAYER_PAYMENT_BEGIN = 'CREATE_TRUELAYER_PAYMENT_BEGIN';
export const CREATE_TRUELAYER_PAYMENT_SUCCESS = 'CREATE_TRUELAYER_PAYMENT_SUCCESS';
export const CREATE_TRUELAYER_PAYMENT_FAIL = 'CREATE_TRUELAYER_PAYMENT_FAIL';

export const GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_BEGIN = 'GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_BEGIN';
export const GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_SUCCESS = 'GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_SUCCESS';
export const GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_FAIL = 'GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_FAIL';
